module.exports = __webpack_public_path__ + "media/images/countrysquared/tt-a52da574d102b12456d9609ee720b889.svg";